import React, { useEffect, useState } from "react";
import CustomModal from "components/Common/CustomModal";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import { ReactComponent as Arrow } from "../../assets/img/Arrowdown.svg";
import api from "api";
import { toast } from "react-toastify";
import { Store } from "StoreContext";

export const inputStyle = {
    backgroundColor: "#F3F3F3",
    border: "none",
    borderRadius: "8px",
    fontFamily: "Outfit",
    width: "100%",
    padding: "12px 17px",
};

const CreateOrder = ({ handleModal, getOrders }) => {
    const store = Store();
    const { user } = store;
    const [selectedNames, setSelectedNames] = useState([]);
    const [brand, setBrand] = useState();
    const [sku, setSKU] = useState();
    const [allBrands, setAllBrands] = useState();
    const [allBatches, setAllBatches] = useState();
    const [open, setOpen] = useState(false);
    const [data, setData] = useState({
        totalCodes: '',
        phone: "",
        description: ''
    })

    const getBrands = () => {
        api("get", "/users?role=brand")
            .then((res) => {
                setAllBrands(res.users);
            })
            .catch((err) => {
                console.log(err);
            });
    };

    const getBatches = () => {
        api("get", `/orders/brand-batches/${brand._id}`)
            .then((res) => {
                setAllBatches(res.batches);
            })
            .catch((err) => {
                console.log(err);
            });
    };

    const createOrder = () => {
        const obj = {
            sku: sku?.name,
            totalCodes: data?.totalCodes,
            phone: data?.phone,
            description: data?.totalCodes,
            brandId: user?._id

        };
        console.log(obj, user?._id)
        api("post", `/orders`, obj)
            .then((res) => {
                handleModal();
                toast.success(res.message);
                getOrders();
            })
            .catch((err) => {
                console.log(err);
            });
    };


    const handleChange = (e) => {
        setData((prev) => ({ ...prev, [e.target.name]: e.target.value }))
    }
    const handleChangeSKU = (e) => {
        setSKU(e.target.value);

    };

    // useEffect(() => {
    //     getBrands();
    // }, []);

    // useEffect(() => {
    //     if (brand?._id) {
    //         getBatches();
    //     }
    // }, [brand?._id]);
    const dummysku = [
        { _id: "1", name: "1" },
        { _id: "2", name: "2" },
        { _id: "3", name: "3" },
    ];

    return (
        <CustomModal
            handleSave={createOrder}
            heading="Create Order"
            buttonName="Submit"
            handleModal={handleModal}
        >
            <p style={{ lineHeight: "1.3" }}>Please provide the details below to request a new order. Once submitted, our admin team will review and contact you for verification. Ensure all required fields are completed to avoid delays.</p>
            <label
                style={{
                    marginTop: "10px",
                    fontWeight: 600,
                    fontSize: "16px",
                    fontFamily: "Outfit",
                    color: "#1C1C1C",
                }}
                htmlFor=""
            >
                Number of SKU's
            </label>
            <br />
            <Select
                value={sku}
                onChange={handleChangeSKU}
                renderValue={() => (sku ? sku.name : "Select")}
                displayEmpty
                sx={{
                    "& .MuiOutlinedInput-notchedOutline": {
                        border: "none",
                    },
                    "& .MuiSelect-select": inputStyle,
                }}
                fullWidth
                IconComponent={(props) => <Arrow {...props} />}
            >
                {dummysku?.map((item) => {
                    return (
                        <MenuItem key={item._id} value={item}>
                            {item.name}
                        </MenuItem>
                    );
                })}
            </Select>
            <label style={{
                marginTop: '10px',
                fontWeight: 600,
                fontSize: '16px',
                fontFamily: "Outfit",
                color: '#1C1C1C'
            }} htmlFor="">Total Amount of Codes</label><br />
            <div className=' text-right'>
                <input onChange={handleChange} name='totalCodes' value={data.totalCodes} placeholder='Enter here' style={inputStyle} type="text" maxLength={24} />

            </div>
            <label style={{
                marginTop: '10px',
                fontWeight: 600,
                fontSize: '16px',
                fontFamily: "Outfit",
                color: '#1C1C1C'
            }} htmlFor="">Phone Number</label><br />
            <div className=' text-right'>
                <input onChange={handleChange} name='phone' value={data.phone} placeholder='Enter here' style={inputStyle} type="text" maxLength={24} />

            </div>

            <label style={{
                fontWeight: 600,
                paddingTop: "5px",
                fontSize: '16px',
                fontFamily: "Outfit",
                color: '#1C1C1C'
            }} htmlFor="">Order Description</label><br />
            <div className=' text-right'>
                <textarea onChange={handleChange} name='description' value={data.description} placeholder='Enter here' maxLength={1000} style={{
                    backgroundColor: '#F3F3F3',
                    border: 'none',
                    borderRadius: '8px',
                    fontFamily: "Outfit",
                    width: "100%",
                    padding: '12px 17px',
                    resize: "none"
                }} type="text" />
                <span style={{
                    color: '#828282',
                    fontSize: '14px',
                    fontWeight: 400,
                    fontFamily: "Outfit",

                }}>{data.description.length}-1000 character</span>
            </div>

        </CustomModal>
    );
};

export default CreateOrder;
